<template>
  <div v-if="displayLicences.length">
    <slot name="label" />
    <template
      v-for="licence in displayLicences"
      :key="licence.year + licence.discipline.codename"
    >
      <AppChip
        small
        :color="licence.year === currentYear ? 'green' : 'grey'"
        :text-color="licence.year === currentYear ? 'text-white' : 'text-white'"
        :aria-label="
          $t(
            `common:discipline.${licence.discipline.codename}`,
            licence.discipline.codename
          )
        "
        class-list="ml-2"
      >
        {{
          $t(
            `common:discipline.short.${licence.discipline.codename}`,
            licence.discipline.codename
          )
        }}
        {{ licence.year }}
      </AppChip>
    </template>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
import { groupBy, orderBy } from "lodash-es";
import dayjs from "@/plugins/dayjs";
import AppChip from "@elements/AppChip.vue";

export function getLatestFEILicences(licences) {
  if (licences.length == 0) return [];
  const currentYear = Number(dayjs().format("YYYY"));

  let licencesByDiscipline = null;
  switch (licences[0].__typename) {
    case "PersonLicence":
      licencesByDiscipline = groupBy(
        licences.filter(l => l.issuer === "FEI" && l.periodType === "SEASON"),
        "disciplineId"
      );
      break;
    case "HorseSportLicence":
      licencesByDiscipline = groupBy(
        licences.filter(l => l.productCodename === "HORSE_SEASON_FEI_LICENCE"),
        "disciplineId"
      );

      break;
  }

  return (
    Object.entries(licencesByDiscipline)
      .reduce((arr, [, licences]) => {
        const discipline = licences[0].discipline;
        const orderedByLatest = orderBy(licences, "year", "desc");
        // If theres future licence, show it with latest
        let index = 0;
        if (orderedByLatest[index].year === currentYear + 1) {
          arr.push({
            discipline,
            year: orderedByLatest[index].year
          });

          index++;
        }

        if (orderedByLatest[index]) {
          // if index increment but in that position may not exist object
          arr.push({
            discipline,
            year: orderedByLatest[index].year
          });
        }

        return arr;
      }, [])
      // Then sort by oldest year to latest
      .sort((a, b) => {
        if (a.year > b.year) return 1;
        else if (b.year == a.year) return 0;
        else return -1;
      })
  );
}

export default defineComponent({
  name: "AppShowFEILicences",
  components: { AppChip },
  props: {
    licences: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    return {
      ...useDisciplineHelper()
    };
  },
  computed: {
    currentYear() {
      return Number(this.$dayjs().format("YYYY"));
    },
    displayLicences() {
      return getLatestFEILicences(this.licences);
    }
  },
  fragments: {
    personLicenceFields: gql`
      fragment _ on PersonLicence {
        id
        issuer
        periodType
        year
        disciplineId
        discipline @client {
          id
          codename
        }
        __typename
      }
    `,
    horseLicenceFields: gql`
      fragment _ on HorseSportLicence {
        id
        productCodename
        year
        disciplineId
        discipline @client {
          id
          codename
        }
        __typename
      }
    `
  }
});
</script>
